export const domainCDMColumns = {
  id: 0,
  name: "",
  datatype: "string",
  mandatory: "",
  format: "",
  key: "",
  reference_data: "",
};
